import {
  Target,
  Lightbulb,
  HeartHandshake,
  TrendingUp,
  FileText,
  PieChart,
  Users,
  Building2,
  DollarSign,
  Activity,
  Layers,
  Radio,
  Search,
  Award,
  Globe2,
} from "lucide-react";

export const PROFILING_HERO_TAGS = [
  { label: "Deep Firmographic Intelligence", icon: Building2 },
  { label: "Decision-Maker Hierarchies", icon: Users },
  { label: "Vendor Selection Criteria", icon: Target },
];

export const MAIN_ADVANTAGES = [
  {
    title: "Laser-Targeted Outreach",
    desc: "Carry out more targeted marketing and sales promotions with verified stakeholder triggers.",
    icon: Target,
  },
  {
    title: "Pain-Point Aligned Solutions",
    desc: "Develop precise solutions mapped directly to the active concerns and roadblocks of potential clients.",
    icon: Lightbulb,
  },
  {
    title: "Need-Driven Service Offerings",
    desc: "Refine your value proposition based on deep real-world intelligence rather than speculative assumptions.",
    icon: Layers,
  },
  {
    title: "Durable Client Relationships",
    desc: "Foster sustainable, highly productive account partnerships with high-value enterprise accounts.",
    icon: HeartHandshake,
  },
];

export const DOSSIER_SECTIONS = [
  { id: "01", title: "Background", category: "Corporate", icon: Building2, desc: "Founding history, corporate structure, global locations, and subsidiary tree." },
  { id: "02", title: "Executive Summary", category: "Core Overview", icon: FileText, desc: "C-suite strategic priorities, business mission, and quarterly corporate milestones." },
  { id: "03", title: "Key Facts", category: "Metrics", icon: Activity, desc: "Headcount, operational footprint, infrastructure data, and core operational metrics." },
  { id: "04", title: "Chief Executive's Address", category: "Leadership", icon: Users, desc: "Key remarks from shareholder calls, visionary direction, and internal company roadmaps." },
  { id: "05", title: "Board & Biographies", category: "Stakeholders", icon: Award, desc: "Full stakeholder profiles, tenure histories, direct reports, and board members." },
  { id: "06", title: "Product Categories", category: "Offerings", icon: Layers, desc: "Full catalog segmentation, product tiers, monetization models, and upcoming launches." },
  { id: "07", title: "Competitive Landscape", category: "Market Analysis", icon: Globe2, desc: "Market share distribution, direct threat evaluation, and competitive differentiators." },
  { id: "08", title: "Key Competing Firms", category: "Market Analysis", icon: Target, desc: "Direct segment rivals, price positioning, and alternative vendor displacement audits." },
  { id: "09", title: "Financial Results", category: "Financials", icon: DollarSign, desc: "Quarterly EBIT, revenue balance sheets, margin velocity, and operational budgets." },
  { id: "10", title: "Five Year Summary", category: "Financials", icon: TrendingUp, desc: "Multi-year historical fiscal performance, compounding growth rates, and shifts in capex." },
  { id: "11", title: "Stock Market Performance", category: "Financials", icon: PieChart, desc: "Valuation dynamics, analyst revisions, dividend distribution, and equity health." },
  { id: "12", title: "Media Monitoring", category: "Intelligence", icon: Radio, desc: "PR tracking, brand sentiment, executive interviews, acquisitions, and compliance audits." },
];

export const EXPERIENCE_PILLARS = [
  {
    icon: Globe2,
    title: "Cross-Industry Domain Mastery",
    desc: "In-depth operational knowledge spanning SaaS, Fintech, Healthcare, Manufacturing, and Logistics.",
  },
  {
    icon: TrendingUp,
    title: "Hands-on Go-To-Market Practice",
    desc: "Extensive sales and marketing battle-tested experience identifying genuine enterprise buying triggers.",
  },
  {
    icon: Search,
    title: "Elite Research & Investigative Telemarketing",
    desc: "Highly skilled interviewers and analysts conversing with executives at all levels to extract actionable insights.",
  },
];